import { useWizardInfo } from 'components/WizardViews/providers/WizardInfoProvider';
import React from 'react';

const WizardStep = ({ component: Component }: { component?: React.ComponentType; step: number }) => {
  if (Component) {
    return <Component />;
  } else {
    throw new Error('No component to render');
  }
};

const Wizard = ({ children }: {
  children: React.ReactElement<typeof WizardStep>[];
}) => {
  const { currentStep } = useWizardInfo();
  return (
    <>
      {React.Children.map(children, (child) => {
        if (
          React.isValidElement<React.ComponentProps<typeof WizardStep>>(child) &&
          child.props.step === currentStep
        ) {
          return <>{child}</>;
        }
      })}
    </>
  );
};

export { Wizard, WizardStep };
